module.exports = __webpack_public_path__ + "img/horizontal_6_3_pp3_7005.c5b0ce2f.png";